/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

// API konfigurace
// V development módu používáme přímo backend URL
// V production módu se použije VITE_API_BASE_URL z .env
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

// LocalStorage klíče
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'menyxo_access_token',
  REFRESH_TOKEN: 'menyxo_refresh_token',
  USER_PROFILE: 'menyxo_user_profile',
} as const

// Časové konstanty
export const TOKEN_REFRESH_THRESHOLD = 600 // Obnovit token 10 minut před expirací (v sekundách)
export const ACTIVE_CHECK_INTERVAL = 300000 // Interval pro kontrolu tokenu v pozadí (5 minut v ms)
export const IDLE_TIMEOUT = 3600000 // Nečinnost před zobrazením dialogu (60 minut v ms)
export const IDLE_DIALOG_TIMEOUT = 300000 // Čas na reakci v dialogu (5 minut v ms)
export const ACTIVITY_THROTTLE = 1000 // Throttling pro activity events (1 sekunda v ms)

// Sidebar
export const SIDEBAR_WIDTH = {
  EXPANDED: 240,
  COLLAPSED: 64,
} as const
